export default function RefundPolicy() {
    return (
        <div className="container-tight max-w-3xl py-16 lg:py-24" data-testid="refund-policy-page">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                Legal
            </p>
            <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
                Cancellation &amp; Refund Policy
            </h1>
            <p className="mt-4 text-sm text-slate-500">Last updated: 11 June 2026</p>

            <div className="prose prose-slate dark:prose-invert mt-10 max-w-none text-slate-600 dark:text-slate-400 leading-relaxed space-y-6">
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        1. Overview
                    </h2>
                    <p>
                        TenderTrackAI Technologies Pvt. Ltd. (&ldquo;TenderTrackAI&rdquo;,
                        &ldquo;we&rdquo;, &ldquo;us&rdquo;) operates a credit-based
                        Software-as-a-Service platform for AI-powered tender document
                        analysis. This policy explains how cancellations and refunds work
                        for our paid plans (Starter ₹299/month, Pro ₹499/month, Business
                        ₹999/month) and any one-time credit purchases. All payments are
                        processed securely through our payment partner, Razorpay.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        2. Subscription Cancellation
                    </h2>
                    <p>
                        You may cancel your subscription at any time from{" "}
                        <strong>Dashboard → Billing</strong> or by emailing
                        support@tendertrackai.com. After cancellation, your plan remains
                        active until the end of the current billing period and you will
                        not be charged again. Unused credits remain available until the
                        end of that billing period.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        3. Refund Eligibility
                    </h2>
                    <p>
                        We offer a <strong>7-day refund window</strong> on your first
                        purchase of any paid plan, provided you have used{" "}
                        <strong>2 or fewer analysis credits</strong> in that period. If
                        you are unsatisfied, write to support@tendertrackai.com within 7
                        days of payment and we will issue a full refund — no questions
                        asked.
                    </p>
                    <p>
                        Refunds are <strong>not</strong> available for: (a) renewal
                        charges after the first billing cycle (cancel before renewal to
                        avoid charges), (b) plans where more than 2 credits have been
                        consumed, and (c) accounts found to be in violation of our Terms
                        of Service.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        4. Failed or Duplicate Payments
                    </h2>
                    <p>
                        If a payment fails but the amount is debited from your account,
                        the amount is typically auto-reversed by your bank within 5–7
                        business days. For duplicate charges, contact us with the payment
                        reference ID and we will refund the duplicate amount in full.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        5. Refund Processing Time
                    </h2>
                    <p>
                        Approved refunds are initiated within{" "}
                        <strong>2 business days</strong> and are credited back to your
                        original payment method (card, UPI, net banking or wallet) within{" "}
                        <strong>5–10 business days</strong>, depending on your bank or
                        payment provider. Refunds are processed through Razorpay.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        6. How to Request a Refund
                    </h2>
                    <p>
                        Email support@tendertrackai.com from your registered email with
                        the subject &ldquo;Refund Request&rdquo;, including your payment
                        reference / order ID and the reason for the request. We respond to
                        all refund requests within 2 business days.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        7. Contact
                    </h2>
                    <p>
                        TenderTrackAI Technologies Pvt. Ltd., Indiranagar, Bengaluru
                        560038, India · support@tendertrackai.com · +91 80-4444-2200
                        (Mon–Sat, 9am–7pm IST).
                    </p>
                </section>
            </div>
        </div>
    );
}
